import { type ReactNode } from 'react';
import { Heading, Paragraph, AlarmClock, SaveMoney } from '@hungryroot/ui-kit';

import styles from './SavingsStats.module.css';

interface Stat {
  metricName: string;
  metricValue: string;
  title: string;
  text: string;
  footnote?: number;
  Icon: (props: { className?: string }) => ReactNode;
}

const stats: Stat[] = [
  {
    metricName: 'more-time',
    metricValue: '6 hrs',
    title: 'More time',
    text: 'of time on average saved each week with your Hungryroot plan.',
    footnote: 1,
    Icon: AlarmClock,
  },
  {
    metricName: 'save-money',
    metricValue: '$200+',
    title: 'Save money',
    text: 'saved on average vs ordering takeout.',
    Icon: SaveMoney,
  },
];

export function SavingsStats() {
  return (
    <section
      data-testid="cancellation-deflection-savings-stats"
      className={styles.container}
    >
      {stats.map(({ metricName, metricValue, title, text, footnote, Icon }) => (
        <div className={styles.stat} key={metricName}>
          <div className={styles.heading}>
            <span className={styles.icon}>
              <Icon />
            </span>
            <Heading variant="H4">{title}</Heading>
          </div>
          <div className={styles.value}>{metricValue}</div>
          <Paragraph as="span" className={styles.text}>
            {text}
            {footnote ? <sup>{footnote}</sup> : null}
          </Paragraph>
        </div>
      ))}
    </section>
  );
}
